import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { TabelPaging } from 'src/app/dashboard/interfaces/table';
import { PCSearchRequestModel } from 'src/app/dashboard/models/pc-search-request-model';
import { PCTableOutputModel } from 'src/app/dashboard/models/pc-table-input-model';
import { CustomizeResponseService } from 'src/app/dashboard/services/customize-response.service';
import { UserApiService } from 'src/app/dashboard/services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import * as _ from 'lodash-es';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';
import { Dropdown } from 'src/app/models/dropdown';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-drop-down-paging',
  templateUrl: './drop-down-paging.component.html',
  styleUrls: ['./drop-down-paging.component.css'],
})
export class DropDownPagingComponent implements OnInit {
  @Input() data?: DropDownPagingInput;

  @Input() ngModelValue: any;
  @Output() ngModelValueChange = new EventEmitter<any>();

  @ViewChild('SearchInput') searchElement!: ElementRef;

  constructor(
    private logger: LoggerService,
    private renderer: Renderer2,
    private responseService: CustomizeResponseService,
    private apiService: UserApiService
  ) {
    this.dropDownData = [];
    this.requestModel = new PCSearchRequestModel();

    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    if (this.data == null) {
      return;
    }
    if (!this.data.isValid) {
      this.data.isValid = true;
    }

    if (!this.data.isDisable) {
      this.data.isDisable = false;
    }

    if (!this.data.defaultValue) {
      this.selectedItem = new Dropdown('', `یک گزینه را انتخاب کنید`);
    } else {
      this.selectedItem = new Dropdown(
        this.data.defaultKey,
        this.data.defaultValue
      );
    }
  }
  public drugSearchForm: FormGroup;

  public requestModel: PCSearchRequestModel;
  public paging?: TabelPaging;

  public dropDownData: any[] = [];
  public dropDownDataBackup: any[] = [];

  public selectedItem!: Dropdown;

  public listClosed: boolean = true;
  public activeSearch: boolean = false;

  public loading: boolean = true;

  public searchBox: string = '';

  public NewName: string = '';

  ngOnInit(): void {
    this.drugSearchForm
      .get('drugBrandName')
      ?.valueChanges.pipe(debounceTime(1000))
      .subscribe((value) => {
        if (this.activeSearch) {
          this.searchOnItems(value);
        } else {
          this.activeSearch = true;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['data'] &&
      changes['data'].currentValue !== undefined
    ) {
      const newData: DropDownPagingInput = changes['data'].currentValue;

      if (newData.endPoint == '') {
        this.logger.addError('cannot find drop down url', false);
        return;
      }

      if (newData.isDisable) {
        this.listClosed = true;
      } else {
        if (newData.hasPaging == false) {
          this.requestModel.pageSize = 10000;
          this.requestModel.paging = false;
        }

        this.getData();
      }
      if (!newData.defaultValue) {
        this.selectedItem = new Dropdown('', `یک گزینه را انتخاب کنید`);
      } else {
        const selectValue= new Dropdown(
          newData.defaultKey,
          newData.defaultValue
        );
        this.selectItem(selectValue);
      }
    }
  }

  public getData() {
    try {
      if (this.data == null) {
        return;
      }
      this.toTop();
      const endPointUrl = `${this.data.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(endPointUrl))) {
        return;
      }

      if (this.requestModel.paging) {
        this.apiService.getAll(new ApiRequestModel(endPointUrl)).subscribe(
          (result) => {
            this.logger.addResponseLog(endPointUrl, result, `Get All`);
            if (result.succeeded) {
              let firstItemOnPage = 1;
              if (result.data?.firstItemOnPage) {
                firstItemOnPage = result.data?.firstItemOnPage;
              }

              const columnName=this.data!.showFieldName;
              this.dropDownData = result.data?.items.map((current) => ({
                id: current.id,
                friendlyName: current[columnName],
              }));

              this.paging = this.responseService.customizePagingSpecificRecord(
                result,
                4
              );
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
      } else {
        this.apiService
          .getWitoutPage(new ApiRequestModel(endPointUrl))
          .subscribe(
            (result) => {
              this.logger.addResponseLog(endPointUrl, result, `Get All`);
              if (result.succeeded) {
                this.dropDownData = result.data!.map((current) => ({
                  id: current.id,
                  friendlyName: current[this.data!.showFieldName],
                }));
                this.dropDownDataBackup=_.cloneDeep(this.dropDownData);
              } else {
                this.logger.addBackEndMessage(result);
              }
              this.loading = false;
            },
            (error) => {
              this.apiService.AddErrorLog(error);
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
      }
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public refreshButton(){
    this.loading=true;
    this.getData();
  }

  public toTop() {
    const itemBox = document.getElementById('drop-down-list-box');
    if (itemBox == null) {
      return;
    }
    itemBox.scrollTop = 0;
  }

  public searchOnBackend(value){
    if (this.data == null) {
      return;
    }
    this.loading = true;
    this.requestModel.pageNumber = 1;
    if (value == null || value == '') {
      this.requestModel.search = '';
    } else {
      this.requestModel.search = `${this.data.searchFieldName}:${value}`;
    }
    this.getData();
  }
  
  public searchOnItems(value) {
    if (this.requestModel.paging) {
      this.searchOnBackend(value);
      return;
    }

    if (value==undefined||value=='') {
      this.dropDownData=_.cloneDeep(this.dropDownDataBackup);
      return;
    }
    
    const searchResult=this.dropDownDataBackup
    .filter((current)=>current.friendlyName.indexOf(value)>=0)

    this.dropDownData=_.cloneDeep(searchResult);
  }

  public emptySearch() {
    this.searchBox = '';
    this.searchOnItems('');
  }

  public selectItem(item) {
    this.selectedItem = item;
    this.listClosed = true;
    this.ngModelValueChange.emit(this.selectedItem);
  }

  public addButton() {
    try {
      if (this.NewName == null || this.NewName == '' || this.data == null) {
        return;
      }

      var backendJson = {};

      if (this.data.fieldNames == null) {
        backendJson['name'] = this.NewName;
        backendJson['persianName'] = this.NewName;
      } else {
        const splitItems = this.NewName.split(' ');

        for (let index = 0; index < this.data.fieldNames.length; index++) {
          const element = this.data.fieldNames[index];
          backendJson[element] = splitItems[index];
        }
      }

      if (this.data.relationId != null && this.data.relationName != null) {
        backendJson[this.data.relationName] = this.data.relationId;
      }

      this.apiService
        .postItem(new ApiRequestModel(this.data.endPoint, backendJson))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.dropDownData.push(
                new Dropdown(result.data.id, this.NewName)
              );
              this.NewName = '';
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (error) {}
  }

  public openDropDown() {
    if (this.data == null) {
      return;
    }
    if (!this.data.isDisable) {
      this.listClosed = !this.listClosed;
      setTimeout(() => {
        if (this.searchElement?.nativeElement!=null) {
          this.searchElement.nativeElement.focus();
        }
      }, 2);
    }
  }

  public onClickedOutside() {
    this.listClosed = true;
  }

  public findDefaultValue(): Dropdown {
    let viewModel = new Dropdown('', `یک گزینه را انتخاب کنید`);

    if (
      this.dropDownData == null ||
      this.dropDownData.length == 0 ||
      this.data == null ||
      this.data.defaultValue == null
    ) {
      return viewModel;
    }

    const foundedItem = this.dropDownData.find(
      (current) => current.id == this.data!.defaultValue
    );

    if (foundedItem == null) {
      return viewModel;
    }

    this.selectItem(foundedItem);
    return foundedItem;
  }

  public parentAction(event: PCTableOutputModel) {
    if (event.action == 'Paging') {
      this.loading = true;
      this.requestModel.pageNumber = event.data;
      this.getData();
    }
  }
}
